export default ()=>{
  // window.onload=function(){
    changeRem();
    window.addEventListener('resize',()=>{
      console.log('resizeee');
      changeRem();
    })
  // }
}

function changeRem(){
  var width=0;
  var baseUnit=16;
  if(window.orientation==90||window.orientation==-90){
    console.log('横屏');
    width=document.documentElement.clientWidth;
    console.log(width);
    document.documentElement.style.fontSize=width/(375/baseUnit)+'px';
    document.querySelector('.container').style.width=document.documentElement.clientWidth+'px';
    document.querySelector('.container').style.height=document.documentElement.clientHeight+'px';
    document.querySelector('.container').style.transform='';
    document.querySelector('.container').style.transformOrigin='';
  }else{
    console.log('竖屏')
    width=document.documentElement.clientHeight;
    console.log(width);
    document.documentElement.style.fontSize=width/(375/baseUnit)+'px';
    document.querySelector('.container').style.width=document.documentElement.clientHeight+'px';
    document.querySelector('.container').style.height=document.documentElement.clientWidth+'px';
    document.querySelector('.container').style.transform='rotate(90deg)';
    // document.querySelector('.container').style.transformOrigin='28% 49.5%';
    document.querySelector('.container').style.transformOrigin='50vw 50vw';

  }
}



// WEBPACK FOOTER //
// ./src/common/forceLandscape.js